var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelledRide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#C71F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2802 22.5H12.3202C11.5621 22.4724 10.8559 22.1078 10.3945 21.5056C9.93309 20.9035 9.76467 20.1267 9.93524 19.3875L10.1152 18.5325C10.3223 17.3751 11.3172 16.5245 12.4927 16.5H19.1077C20.2833 16.5245 21.2782 17.3751 21.4852 18.5325L21.6652 19.3875C21.8358 20.1267 21.6674 20.9035 21.206 21.5056C20.7446 22.1078 20.0384 22.4724 19.2802 22.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1752 15H15.4252C13.7684 15 12.4252 13.6569 12.4252 12V10.02C12.4232 9.35105 12.6881 8.70892 13.1611 8.23589C13.6342 7.76287 14.2763 7.49801 14.9452 7.50001H16.6552C17.3242 7.49801 17.9663 7.76287 18.4394 8.23589C18.9124 8.70892 19.1772 9.35105 19.1752 10.02V12C19.1752 12.7957 18.8592 13.5587 18.2966 14.1213C17.734 14.6839 16.9709 15 16.1752 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledRide);
export default __webpack_public_path__ + "static/media/cancelledRide.8ae919b8e6837db5c86e82d510b59a5a.svg";
export { ForwardRef as ReactComponent };